var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"cookie_bar"},[(_vm.type === 'modal')?_c('cookie-modal',{on:{"confirm":_vm.confirm}}):_c('cookie-banner',{on:{"confirm":_vm.confirm}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae6b6b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookies/CookieNotification.vue
// module id = 361
// module chunks = 1